// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '80'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'address',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'charge_points',
    label: '',
    Object: 'value',
    width: '150'
  }]
}
